import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PrimeNGConfig } from 'primeng/api';
import { LoaderService } from '../services/loader.service';
import { AppSettingService } from '../services/app-setting.service';
import { MetadataProp } from '../models/metadata-prop-model';
import { FeedbackComponent } from '../components/feedback/feedback.component'; 

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ADAMS Public Search';
  loading: boolean = false;
  lastIndexUpdate = '';
  currentYear = (new Date()).getFullYear();
  mdItems?: MetadataProp[];
  @ViewChild(FeedbackComponent) feedbackComponent!: FeedbackComponent;
  openFeedback() {
    this.feedbackComponent.display = true;
  }
  constructor(private primengConfig: PrimeNGConfig, private router: Router, private loaderService: LoaderService, 
    private asSvc: AppSettingService) {
  }

  ngOnInit(): void {
    this.primengConfig.ripple = true;
    this.subscribeLoader();
    this.updateLastIndex();
  }

  updateLastIndex() {
    this.asSvc.getLastIndexObservable().subscribe((lastIndex) => {
      this.lastIndexUpdate = lastIndex;
    });
  }

  subscribeLoader() {
    this.loaderService.isLoading.subscribe((v) => {
      this.loading = v;
    });
  }
}
